import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showKnowledge: false,
  currentYear: JSON.parse(localStorage.getItem("currentYear")),
};

const knowledgeSlice = createSlice({
  name: "didShowKnowledge",
  initialState,
  reducers: {
    setShowKnowledge: (state, action) => {
      state.showKnowledge = action.payload;
    },
    setCurrentYear: (state, action) => {
      state.currentYear = action.payload;
      localStorage.setItem("currentYear", JSON.stringify(action.payload));
    },
  },
});

export const { setShowKnowledge, setCurrentYear } = knowledgeSlice.actions;
export default knowledgeSlice.reducer;
